import { render, staticRenderFns } from "./FirmRemarks.vue?vue&type=template&id=08b838ec"
import script from "./FirmRemarks.vue?vue&type=script&lang=js"
export * from "./FirmRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports